var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center p-t-50 text-20 text-gray"},[_c('p',{staticClass:"m-t-50"},[_c('Icon',{attrs:{"type":"ios-bulb-outline","size":"200"}})],1),_c('p',{staticClass:"m-t-20"},[_vm._v("当前用户未配置权限，请联系管理员或切换其他租户!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }